import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { AssetGroup } from '../entities/assets/assetgroup.entity';
import { AssetGroupTreeAssigment } from '../entities/assets/assetgrouptreeassigment.entity';
import { AssetGroupTree } from '../entities/assets/assetgrouptree.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class AssetGroupTreeAssigmentService extends ODataEntityService<AssetGroupTreeAssigment> {
  constructor(protected client: ODataClient) {
    super(client, 'AssetGroupTreeAssigment', 'entities.assets.AssetGroupTreeAssigment');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public assetGroup(entity: EntityKey<AssetGroupTreeAssigment>): ODataNavigationPropertyResource<AssetGroup> {
    return this.entity(entity).navigationProperty<AssetGroup>('assetGroup');
  }
  public assetGroupTree(entity: EntityKey<AssetGroupTreeAssigment>): ODataNavigationPropertyResource<AssetGroupTree> {
    return this.entity(entity).navigationProperty<AssetGroupTree>('assetGroupTree');
  }
  public status(entity: EntityKey<AssetGroupTreeAssigment>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<AssetGroupTreeAssigment>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
